"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
const theme_1 = require("../../components/theme");
const mithril_1 = require("../../mithril");
const dashboard_table_style_1 = require("./dashboard.table.style");
(0, theme_1.addStyles)(dashboard_table_style_1.Style);
exports.Table = {
    view(title, header, rows) {
        const headerChildren = [];
        let i = 0;
        for (const colHeader of header) {
            headerChildren.push((0, mithril_1.m)('th', { className: `${dashboard_table_style_1.CSS.MDL.cell} ${rows[0][i].attrs.className}` }, colHeader));
            i++;
        }
        const bodyChildren = [];
        for (const row of rows) {
            const rowChildren = [];
            for (const col of row) {
                rowChildren.push((0, mithril_1.m)('td', { className: `${dashboard_table_style_1.CSS.cell} ${dashboard_table_style_1.CSS.MDL.cell} ${col.attrs.className}` }, col));
            }
            bodyChildren.push((0, mithril_1.m)('tr', { className: dashboard_table_style_1.CSS.row }, rowChildren));
        }
        return (0, mithril_1.m)('div', { className: dashboard_table_style_1.CSS.container }, [
            (0, mithril_1.m)('div', { className: dashboard_table_style_1.CSS.title }, title),
            (0, mithril_1.m)('table', { className: `${dashboard_table_style_1.CSS.body} ${dashboard_table_style_1.CSS.MDL.table}` }, [
                (0, mithril_1.m)('thead', { className: dashboard_table_style_1.CSS.header }, headerChildren),
                (0, mithril_1.m)('tbody', bodyChildren)
            ])
        ]);
    }
};
//# sourceMappingURL=dashboard.table.js.map